<ng-container *ngIf="showComponent">
  <mat-expansion-panel
    class="suggestion-expansion-panel"
    [expanded]="panelOpenState"
    (opened)="onOpened()"
    (closed)="onClosed()"
    (afterExpand)="scrollToExpanded()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="suggestion-word" (dblclick)="onDoubleClickPanel($event)">
        {{ suggestion.word }}
      </mat-panel-title>

      <app-disclosure-controls
        [thisItemPath]="thisItemPath"
        [speakText]="suggestion.word"
        [extendedSpeakText]="suggestion.definition ?? ''"
        [readDefinitionWhenExpanded]="true"
        [expanded]="panelOpenState"
        (requestReplace)="onMakeReplacement($event)"
      >
      </app-disclosure-controls>
    </mat-expansion-panel-header>

    <p class="suggestion-definition">
      {{ suggestion.definition }}
    </p>
  </mat-expansion-panel>
</ng-container>
